export enum Endpoints {
  BANK = 'financeiras',
  BANK_ACCOUNT = 'contas-bancarias',
  BRANDS = 'marcas',
  CITIES = 'municipios',
  COLORS = 'cores',
  COMPANY = 'empresas',
  CUSTOMERS = 'clientes',
  FUELS = 'combustiveis',
  LOGIN = 'auth/access-token',
  MODELS = 'modelos',
  PATIO_TIME = 'tempos-patio',
  PAYMENT_CONDITION = 'formas-pagamentos',
  PAYMENT_CONDITION_VEHICLE_EXCHANGE = 'formas-pagamentos/veiculo-troca',
  REFRESH = 'auth/refresh-token',
  SALE_TYPES = 'tipos-venda', //nao existe rota api
  SALES = 'fichas-vendas',
  TAXES = 'taxas',
  UFS = 'unidades-federativas',
  UNITY = 'unidades',
  USER = 'usuarios',
  VEHICLE_KM = 'kms-veiculo',
  VEHICLES = 'veiculos',
  PARTNERS = 'fornecedores',
  ANEXO = 'anexos',
  PARAMETERS = 'parametros',
  ADDRESS_TYPE = 'tipo-endereco'
}
